import type { RouteRecordRaw } from 'vue-router';

export const treatmentPlansRoutes: RouteRecordRaw[] = [
  {
    path: 'treatment-plans',
    name: 'treatment-plans',
    component: () => import('./pages/TreatmentPlansListPage.vue'),
    meta: { title: 'Treatment plans', requiresAuth: true, permission: 'view_treatment_plans' },
  },
  {
    path: 'treatment-plans/new',
    name: 'treatment-plans.create',
    component: () => import('./pages/TreatmentPlanEditorPage.vue'),
    meta: { title: 'New treatment plan', requiresAuth: true, permission: 'create_treatment_plans' },
  },
  {
    path: 'treatment-plans/:id',
    name: 'treatment-plans.show',
    component: () => import('./pages/TreatmentPlanEditorPage.vue'),
    meta: { title: 'Treatment plan', requiresAuth: true, permission: 'view_treatment_plans' },
  },
];
